import { Badge, Card, IconButton, LuIcon, Separator, Text } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, Fragment, memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import type { RouteLinksCardRoute } from "./typings"

interface RouteLinksCardProps extends Omit<ComponentPropsWithRef<typeof Card>, "children"> {
	routes: RouteLinksCardRoute[]
}

export const RouteLinksCard = memo<RouteLinksCardProps>((props) => {
	const { ref, routes, className, size = "sm", ...rest } = props

	return (
		<Card ref={ref} className={cx("p-0!", className)} size={size} {...rest}>
			<ul className="flex flex-col">
				{routes.map((route, index) => {
					const { icon, label, description, ...rest } = route

					return (
						<Fragment key={route.to}>
							<Link
								className="hover:bg-(--base-a3) active:bg-(--base-a4) flex size-full w-full items-center gap-4 p-4"
								{...rest}
							>
								<Badge icon variant="soft" size="md" accentColor="base">
									<LuIcon icon={icon} />
								</Badge>
								<Text className="grow">
									{label}
									<br />
									<Text accentColor="base" size="sm">
										{description}
									</Text>
								</Text>
								<IconButton size="sm" variant="ghost" accentColor="base">
									<LuIcon icon={modelIconMapping.chevronRight} />
								</IconButton>
							</Link>

							{index !== routes.length - 1 && <Separator size="full" />}
						</Fragment>
					)
				})}
			</ul>
		</Card>
	)
})
RouteLinksCard.displayName = "RouteLinksCard"
